import { Grid, Typography } from "@mui/material";
import MemberTypeWiseCirculation from "./MemberTypeWiseCirculation";
import MaterialTypeWiseCirculation from "./MaterialTypeWiseCirculation";
import { GetCirculationWidgets } from "features/libraryDashboard/api/hooks";
import { useEffect, useState } from "react";
import { ICirculationResult } from "features/libraryDashboard/api/types";

const CirculationStatistics = () => {
  const { data: result } = GetCirculationWidgets();
  const [circulation, setCirculation] = useState<ICirculationResult>();

  useEffect(() => {
    if (result?.status === 200) {
      setCirculation(result?.apiData);
    }
  }, [result]);

  return (
    <>
      <Grid>
        <Typography variant="h2">Circulation</Typography>
      </Grid>
      <Grid container spacing={2.5} sx={{ my: 1 }}>
        <Grid item sm={12} md={6} xs={12}>
          <MemberTypeWiseCirculation data={circulation?.memberTypeWiseIssuedOverDue} />
        </Grid>
        <Grid item sm={12} md={6} xs={12}>
          <MaterialTypeWiseCirculation data={circulation?.materialTypeWiseIssuedOverDue} />
        </Grid>
      </Grid>
    </>
  );
};
export default CirculationStatistics;
